import type { FaireProductEntity } from "../../entity_types/product";

export const p_g7k8ya2wbv: FaireProductEntity = {
  token: "p_g7k8ya2wbv",
  type: "product",
  name: "18K Gold PVD Stainless Steel Teardrop CZ Lariat Necklace",
  brandToken: "b_99ch5ye698",
  brandName: "Unknown Brand",
  imageUrl:
    "https://cdn.faire.com/fastly/537abdee92d6268d4f6ea74618e676d6d3f98d800c8586b93a099da232a09dd9.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/c1e948eeacb229ea99ce8d31141846dfaf50de0fd101e5e9e09731112b3d5704.jpeg",
    "https://cdn.faire.com/fastly/7baf0198c7f97d154717c7f4a3f2c61de725bf35505e9cdc6354b664e4c89f95.jpeg",
    "https://cdn.faire.com/fastly/1bbdf7932d29f8f1245cc0cfb74cfc649b9f49e405e056dfae0b70eb5f9ab39e.jpeg",
  ],
  priceDollars: 33.86,
  description:
    'Add a touch of elegance to any outfit with this Lariat Necklace CZ Stone. The lariat style showcases two sparkling diamond-like accents, adding a touch of glamour that makes this necklace perfect for special occasions or everyday elegance. Crafted from premium stainless steel with an 18K gold PVD finish, this necklace delivers a luxurious gold look that is resistant to tarnishing and ensures long-lasting wear.\n\n✦ 100% Waterproof, Non-tarnish, Hypoallergenic\n✦ Quality That Lasts\n✦ Designed for All Skin Types\n✦ Perfect for Every Budget\n\n- PVD COATING -\nWe use the process of PVD Coating our 18K Gold jewelry over 316L surgical grade stainless steel for a non-tarnish, hypoallergenic, polished finish that will hold up best to everyday wear and will never turn your customer\'s skin green.\n\nApprox. Length: 16"+2" + 3" Drop\nApprox. Dimensions: 10mm x 7mm(Large Pendant) / 4mm x 4mm(Small Pendant)\nApprox. Weight: 3.4 grams',
  tags: [],
  msrpDollars: 67.72,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:25:41.117Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
